import { Component, inject } from '@angular/core';

import { NotificationLevel, NotificationsService } from '@eiq/notifications';
import { CustomTerm, QuestionType } from '@empathy/survey/base';

import { SurveyEditorService } from '../../../services/survey-editor.service';

@Component({
  selector: 'empathy-question-terms-form',
  templateUrl: 'question-terms-form.component.html',
  styleUrl: './question-terms-form.component.scss'
})
export class QuestionTermsFormComponent {
  surveyEditorService = inject(SurveyEditorService);

  readonly QuestionType = QuestionType;

  private notificationService = inject(NotificationsService);

  onCsvBlocksImport(csvContent: CustomTerm[]): void {
    const addedTerms = this.surveyEditorService.questionCsvBlocksImport(csvContent);

    if (addedTerms) {
      this.notificationService.open({
        level: NotificationLevel.Success,
        title: 'New terms added',
        message: `${addedTerms} terms were successfully added to the Block terms list.`
      });
    } else {
      this.notificationService.open({
        level: NotificationLevel.Info,
        title: 'No terms added',
        message: 'No terms were added to the Block terms list. The CSV file might be empty or all the terms were already present.'
      });
    }
  }

  onCsvFlagsImport(csvContent: CustomTerm[]): void {
    const addedTerms = this.surveyEditorService.questionCsvFlagsImport(csvContent);

    if (addedTerms) {
      this.notificationService.open({
        level: NotificationLevel.Success,
        title: 'New terms added',
        message: `${addedTerms} terms were successfully added to the Flag terms list.`
      });
    } else {
      this.notificationService.open({
        level: NotificationLevel.Info,
        title: 'No terms added',
        message: 'No terms were added to the Flag terms list. The CSV file might be empty or all the terms were already present.'
      });
    }
  }
}
